export default __webpack_public_path__ + "static/media/Error.22fa069a.png";